import {
  __publicField
} from "./chunk-PKBMQBKP.js";

// src/error-boundary.tsx
import { Component } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_FALLBACK = /* @__PURE__ */ jsxs("div", { style: { padding: "20px", textAlign: "center", fontFamily: "system-ui, sans-serif" }, children: [
  /* @__PURE__ */ jsx("h2", { style: { color: "#dc2626", marginBottom: "10px" }, children: "Something went wrong" }),
  /* @__PURE__ */ jsx("p", { style: { color: "#6b7280" }, children: "We've been notified and are working on a fix." })
] });
var SentryErrorBoundary = class extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { error: null });
    __publicField(this, "resetError", () => {
      this.setState({ error: null });
    });
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    import("@sentry/react").then(({ captureException, withScope }) => {
      withScope((scope) => {
        scope.setExtra("componentStack", errorInfo.componentStack);
        captureException(error);
      });
    }).catch(() => {
    });
    this.props.onError?.(error, errorInfo);
  }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const { fallback } = this.props;
    if (typeof fallback === "function") return fallback({ error, resetError: this.resetError });
    return fallback ?? DEFAULT_FALLBACK;
  }
};
function withSentryErrorBoundary(WrappedComponent, options = {}) {
  const WithBoundary = (props) => /* @__PURE__ */ jsx(SentryErrorBoundary, { ...options, children: /* @__PURE__ */ jsx(WrappedComponent, { ...props }) });
  WithBoundary.displayName = `withSentryErrorBoundary(${WrappedComponent.displayName ?? WrappedComponent.name ?? "Component"})`;
  return WithBoundary;
}
export {
  SentryErrorBoundary,
  withSentryErrorBoundary
};
